import { SectionVM, TrascrizioneMatrimonioAtti } from 'civil-status/view-models/step-form';

export const transformerTrascrizioneMatrimonioAtti = (
  idEvento?: number,
  dataSection?: SectionVM
): TrascrizioneMatrimonioAtti | undefined => {
  if (!dataSection) {
    return undefined;
  }

  return {
    key: {
      idEvento,
    },
    dataComunicazione: dataSection.dateTranscription
      ? dataSection.dateTranscription.toFormat('yyyy-MM-dd')
      : undefined,
    trascrizione: dataSection?.templateTranscriptionText || undefined,
    dichiarazione: dataSection?.typeRequest || undefined,
  };
};
